module.exports = __webpack_public_path__ + "static/media/SizeGood.8bc56eeb.png";